import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Inicio',
    href: '#inicio'
  }, {
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'Antes y Después',
    href: '#resultados'
  }, {
    name: 'Nosotros',
    href: '#nosotros'
  }, {
    name: 'Contacto',
    href: '#contacto'
  }];
  return <nav className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-primary/95 backdrop-blur-md border-b border-gold' : 'bg-primary border-b border-transparent'}`} data-id="element-239">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-240">
        <div className="flex justify-between items-center h-24" data-id="element-241">
          {/* Logo */}
          <div className="flex items-center gap-3" data-id="element-242">
            <img src="https://cdn.magicpatterns.com/uploads/suW15tD8wF6YJTQp7zP6qm/qwwqqwqwqwqwqw-removebg-preview.png" alt="Odontología Estética Logo" className="h-16 sm:h-20 w-auto logo-invert" data-id="element-243" />
            <span className="text-white font-bold text-base sm:text-lg tracking-wide hidden sm:block" data-id="element-244">
              ODONTOLOGÍA ESTÉTICA
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-245">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-white hover:text-gold transition-colors text-sm font-medium" data-id="element-246">
                {link.name}
              </a>)}
            <a href="https://wa.me/573015892967" target="_blank" rel="noopener noreferrer" className="bg-gold hover:bg-gold-hover text-primary font-semibold px-6 py-2.5 rounded-lg transition-colors" data-id="element-247">
              Agendar Cita
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-248">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-gold p-2" aria-label="Toggle menu" data-id="element-249">
              {isMobileMenuOpen ? <X size={28} data-id="element-250" /> : <Menu size={28} data-id="element-251" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && <div className="fixed inset-0 top-24 bg-primary z-40 flex flex-col items-center pt-10 px-4 h-[calc(100vh-96px)]" data-id="element-252">
          <div className="flex flex-col space-y-6 w-full max-w-sm text-center" data-id="element-253">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-white hover:text-gold text-xl font-medium py-3 border-b border-border" data-id="element-254">
                {link.name}
              </a>)}
            <a href="https://wa.me/573015892967" target="_blank" rel="noopener noreferrer" className="bg-gold text-primary font-bold text-lg px-6 py-4 rounded-lg mt-8 w-full" data-id="element-255">
              Agendar Cita
            </a>
          </div>
        </div>}
    </nav>;
}